var $export = require('./$.export')
  , define  = require('./$.object-define');

$export($export.S + $export.F, 'Object', {define: define});


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.object.define.js
// module id = 1144
// module chunks = 0